import React from 'react';
import { SettingsModal } from '../settings/SettingsModal';
import { SearchModal } from '../modals/SearchModal';
import { MergeViewModal } from '../modals/MergeViewModal';
import { DailyConfirmModal } from '../modals/DailyConfirmModal';
import { ToolDrawerModal, WorkspaceToolType } from '../modals/ToolDrawerModal';

export interface AppModalsProps {
  isSettingsOpen: boolean;
  activeTool: WorkspaceToolType;
  onCloseSettings: () => void;
  onCloseActiveTool: () => void;
  onSelectActiveTool: (tool: Exclude<WorkspaceToolType, null>) => void;
}

export const AppModals: React.FC<AppModalsProps> = ({
  isSettingsOpen,
  activeTool,
  onCloseSettings,
  onCloseActiveTool,
  onSelectActiveTool,
}) => {
  return (
    <>
      <SettingsModal isOpen={isSettingsOpen} onClose={onCloseSettings} />
      <ToolDrawerModal
        activeTool={activeTool}
        onClose={onCloseActiveTool}
        onSelectTool={onSelectActiveTool}
      />
      <SearchModal />
      <MergeViewModal />
      <DailyConfirmModal />
    </>
  );
};
